import React, { useEffect, useRef, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { getAllProjectReport, setLimit, setSearch, setSkip } from '../store/projectReportSlice'
import { loginState } from '../../login/login.slice'
import SaveProjectListTable from './reportTableList'
import { Modal, Spin } from 'antd'
import { debounce } from 'lodash'
import EditReport from '../../reports/reportsTimeSheet/EditReport'

const SaveReportTab = () => {
    const dispatch = useDispatch()
    const { userProfile } = useSelector(loginState)
    const { isLoading, search, skip, limit } = useSelector(
        (state) => state.projectReportSlice
    )
    const [showWorkReport, setShowWorkReport] = useState(false)
    const [reportId, setReportId] = useState(null)
    const modalOpenRef = useRef(false)

    useEffect(() => {
        if (!showWorkReport) {

            dispatch(
                getAllProjectReport({
                    projectId: userProfile?.activeProject?._id,
                    limit: limit,
                    skip: skip,
                    reportName: search,
                })
            )
        }
    }, [dispatch, userProfile?.activeProject?._id, search, limit, skip, showWorkReport])

    useEffect(() => {
        if (!showWorkReport) {
            dispatch(setSearch(""))
            dispatch(setSkip(skip));
            dispatch(setLimit(limit));
        }
    }, [showWorkReport])

    // wrapper function for both UI & browser back
    const confirmClose = (onConfirm) => {
        if (modalOpenRef.current) return // prevent multiple modals
        modalOpenRef.current = true

        Modal.confirm({
            title: (
                <span
                    style={{
                        fontFamily: '"Nunito Sans", sans-serif',
                        fontWeight: 600,
                    }}
                >
                    Discard Changes?
                </span>
            ),
            content: (
                <span style={{ fontFamily: '"Nunito Sans", sans-serif' }}>
                    You have unsaved changes in this report. If you go back now,
                    all your edits will be lost. Are you sure you want to
                    continue?
                </span>
            ),
            okText: 'Yes, discard',
            cancelText: 'No, stay',
            okButtonProps: {
                style: {
                    backgroundColor: '#4F46E5',
                    borderColor: '#4F46E5',
                    color: '#fff',
                },
            }, // red
            cancelButtonProps: {
                style: { color: '#000000ff', borderColor: '#4F46E5' },
            }, // blue text
            onOk: () => {
                modalOpenRef.current = false
                if (onConfirm) onConfirm()
            },
            onCancel: () => {
                modalOpenRef.current = false
                if (showWorkReport) {
                    window.history.pushState(null, '')
                }
            },
        })
    }

    useEffect(() => {
        if (!showWorkReport) return

        const handlePopState = (event) => {
            event.preventDefault()
            confirmClose(() => {
                setShowWorkReport(false)
            })
        }

        // lock state
        window.history.pushState(null, '')
        window.addEventListener('popstate', handlePopState)

        return () => {
            window.removeEventListener('popstate', handlePopState)
        }
    }, [showWorkReport])

    return (
        <>
            {!showWorkReport ? (
                <SaveProjectListTable
                    setShowWorkReport={setShowWorkReport}
                    showWorkReport={showWorkReport}
                    setReportId={setReportId}
                />
            ) : (
                <EditReport
                    setShowWorkReport={() =>
                        confirmClose(() => setShowWorkReport(false))
                    }
                    reportId={reportId}
                />
            )}
        </>
    )
}

export default SaveReportTab
